import { FC } from 'react';
import { Image } from '~/components/image';
import { IRichArticleDetail } from 'shared/models';
import { useTranslation } from 'react-i18next';
import { ImmersivePostItemAtoms } from '@discover/body/immersive-post/immersive-post-item/atoms';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import _clamp from 'lodash/clamp';

import './style.scss';

export const ArticleLargeImage: FC = () => {
  const { t } = useTranslation();
  const { largeImage, title } = useScopedAtomValue(ImmersivePostItemAtoms.$CurrentArticle) as IRichArticleDetail;
  const { width, height, url } = largeImage;

  const alt = t('own_picture').replace('%s', title);

  return (
    <div className="article-large-image" style={{ paddingBottom: `${_clamp(height / width, 3 / 4, 4 / 3) * 100}%` }}>
      <Image src={url} alt={alt} />
    </div>
  );
};
